import { render, staticRenderFns } from "./recommendations.vue?vue&type=template&id=a134c2b6&scoped=true&shadow"
import script from "./recommendations.vue?vue&type=script&lang=js&shadow"
export * from "./recommendations.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "a134c2b6",
  null
  ,true
)

export default component.exports